export enum StructureHeader {
  Hearing = '1',
  Exhibit = '2',
  Objection = '3',
  CaseNumber = '4',
  CaseName = '5',
}

export enum StructureFooter {
  Footnote = '1',
  ClaimCount = '3',
}

export enum FootnoteAppear {
  First = '1',
  All = '4',
}

interface ExhibitStructure {
  header: StructureHeader[];
  footer: StructureFooter[];
  displayObjection?: boolean;
}

export interface ExhibitFooter {
  text: string;
  optionId: FootnoteAppear;
}

export type ExhibitFields = {
  exhibitNumber: string;
  objectionBasis: string;
  resolutionTypeId?: number;
  resolutionSubStatusId?: number;
  resolutionActionNameId?: number;
  footer: ExhibitFooter[];
  structure: ExhibitStructure;
};

export const emptyFooter: ExhibitFooter = {
  text: '',
  optionId: FootnoteAppear.First,
};

export const toStructureFooter = (value: number | string | undefined) => {
  const result = `${value}` as StructureFooter;
  return Object.values(StructureFooter)?.includes(result) ? result : undefined;
};

export const toStructureHeader = (value: number | string | undefined) => {
  const result = `${value}` as StructureHeader;
  return Object.values(StructureHeader)?.includes(result) ? result : undefined;
};

export const toFootnoteAppear = (value: number | string | undefined) => {
  const result = `${value}` as FootnoteAppear;
  return Object.values(FootnoteAppear)?.includes(result) ? result : undefined;
};
